module.exports = __webpack_public_path__ + "img/2.e67bc13f.jpg";